import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { AppRoutes, NotificationsRoutes } from '@core';
import { FeatureFlag, FeatureFlagHandler } from '@feature-flags';
import { Observable } from 'rxjs';
import { OrIconComponent } from '@ui-components';

@Component({
  selector: 'lib-dashboard-navbar',
  templateUrl: './dashboard-navbar.component.html',
  styleUrls: ['./dashboard-navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [OrIconComponent],
  standalone: true
})
export class DashboardNavbarComponent {
  private readonly router: Router = inject(Router);
  private readonly featureFlagHandler: FeatureFlagHandler = inject(FeatureFlagHandler);

  private readonly rankFF$: Observable<boolean> = this.featureFlagHandler.isEnabled$(FeatureFlag.RANK);

  readonly rankFF: Signal<boolean | undefined> = toSignal<boolean>(this.rankFF$);

  goToMyGames(): void {
    this.router.navigateByUrl(AppRoutes.MY_GAMES);
  }

  goToAlerts(): void {
    this.router.navigateByUrl(`${AppRoutes.NOTIFICATIONS}/${NotificationsRoutes.ALERTS}`);
  }

  goToRank(): void {
    this.router.navigateByUrl(`${AppRoutes.RANK}`);
  }
}
